





















































import { Component, Vue } from "vue-property-decorator";
import RecordRTC, { invokeSaveAsDialog } from "recordrtc";
import moment from "moment";
import Chime from "@/resources/mixins/chime/chime";
import { mixins } from "vue-class-component";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import RecordGuideComponent from "@/app/components/modals/recordGuide/recordGuide.component.vue";
import { i18n } from "@/resources/locales";

@Component({
  name: "record-options-component",
  components: { RecordGuideComponent },
})
export default class RecordOptionsComponent extends mixins(
  FloatMenuAnimation,
  Chime
) {
  recorder: RecordRTC = null;
  isRecordingStarted = false;
  isStoppedRecording = true;
  isPauseRecording = false;
  activeGuide = false;
  isOpen = false;
  screen = null;
  duration = moment().startOf("day");
  mounted() {
    const container = document.getElementById("record-options-container");
    const observer = new MutationObserver((mutations, observer) => {
      for (let { type, target } of mutations) {
        if (type === "attributes" && target["style"].opacity === "1") {
          const record_guide = localStorage.getItem("record_guide") === "true";
          if (record_guide && !this.isOpen) {
            this.isOpen = true;
            this.startRecord();
          }
          this.activeGuide = !record_guide;
        }
        if (type === "attributes" && target["style"].opacity === "0") {
          this.stopRecord();
        }
      }
    });
    observer.observe(container, { attributes: true });
  }
  closeRecord() {
    if (!this.isRecordingStarted) this.closeRecordOptions();
  }
  invokeGetDisplayMedia(success, error) {
    const displayMediaStreamConstraints = {
      video: true,
      audio: false,
    };

    if (navigator.mediaDevices.getDisplayMedia) {
      navigator.mediaDevices
        .getDisplayMedia(displayMediaStreamConstraints)
        .then(success)
        .catch(error);
    }
  }
  addStreamStopListener(stream, callback) {
    stream.addEventListener(
      "ended",
      () => {
        callback();
        callback = () => {
          // do nothing
        };
      },
      false
    );
    stream.addEventListener(
      "inactive",
      () => {
        callback();
        callback = () => {
          // do nothing
        };
      },
      false
    );
    stream.getTracks().forEach(function (track) {
      track.addEventListener(
        "ended",
        function () {
          callback();
          callback = () => {
            // do nothing
          };
        },
        false
      );
      track.addEventListener(
        "inactive",
        () => {
          callback();
          callback = () => {
            // do nothing
          };
        },
        false
      );
    });
  }
  captureScreen(callback) {
    this.invokeGetDisplayMedia(
      (screen) => {
        this.addStreamStopListener(screen, () => {
          document.getElementById("btn-stop-recording").click();
        });
        this.screen = screen;
        callback(screen);
      },
      (error) => {
        switch (error["message"]) {
          case "Could not start video source":
          case "Permission denied by system": {
            this.$vs.notification({
              sticky: true,
              buttonClose: true,
              duration: "none",
              clickClose: true,
              position: "bottom-center",
              color: "danger",
              title: i18n.t("notifications.devices.title"),
              text: i18n.t("notifications.devices.noPermissions", {
                devices: i18n.t("notifications.devices.record"),
              }),
            });
            if (localStorage.getItem("OSName") == "Mac/iOS") {
              window.open(
                "x-apple.systempreferences:com.apple.preference.security?Privacy_ScreenCapture"
              );
            }
            break;
          }
        }
        console.error(error["message"]);
      }
    );
  }
  startRecord() {
    if (this.isPauseRecording && this.isRecordingStarted) {
      this.resumeRecord();
    } else {
      this.captureScreen(async (screen) => {
        const audioContext = new AudioContext();
        const voiceStream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false,
        });
        const audio = document.getElementById("my-audio-element") as any;
        const audioStream = audio.captureStream();

        const dest = audioContext.createMediaStreamDestination();

        const audioIn_01 = audioContext.createMediaStreamSource(voiceStream);
        const audioIn_02 = audioContext.createMediaStreamSource(audioStream);
        audioIn_01.connect(dest);
        audioIn_02.connect(dest);

        let tracks = [...screen.getTracks(), ...dest.stream.getTracks()];
        this.recorder = new RecordRTC(new MediaStream(tracks), {
          type: "video",
          mimeType: "video/webm;codecs=h264",
          timeSlice: 1000, // pass this parameter
          onTimeStamp: (timestamp, timestamps) => {
            this.duration.add(1, "s");
            document.getElementById("time").innerHTML =
              this.duration.format("HH:mm:ss");
          },
        });

        this.recorder.startRecording();
        this.isRecordingStarted = true;
        this.isStoppedRecording = false;
        await this.sendStartRecord();
      });
    }
  }
  stopRecord() {
    if (!this.isStoppedRecording && this.isRecordingStarted) {
      this.recorder.stopRecording(async () => {
        this.screen.stop();
        // this.addStreamStopListener(this.screen, () => (this.screen = null));
        this.isRecordingStarted = false;
        this.isPauseRecording = false;
        this.isStoppedRecording = true;
        this.isOpen = false;
        this.duration = moment().startOf("day");
        await this.sendStopRecord();
        document.getElementById("time").innerHTML = "00:00:00";
        const blob = await this.recorder.getBlob();
        invokeSaveAsDialog(
          blob,
          `nubii_session_${moment().format("DDMMYYHHmm")}.mov`
        );
      });
    }
  }
  pauseRecord() {
    this.isPauseRecording = true;
    this.recorder.pauseRecording();
  }
  resumeRecord() {
    this.isPauseRecording = false;
    this.recorder.resumeRecording();
  }
}
